import { createStyles } from '@material-ui/core';
const styles = (): any =>
    createStyles({
        root: {},
    });
export default styles;
